import moengage from '@moengage/web-sdk';

let initialized = false;

const readGlobalCfg = () => (typeof window !== 'undefined' ? window.__VUMEDI_MOENGAGE_CONTEXT__ || {} : {});

const whenSdkReady = (callback) => {
    const handler = (event) => {
        if (event.detail && event.detail.name === 'SDK_INITIALIZATION_COMPLETED') {
            window.removeEventListener('MOE_LIFECYCLE', handler);
            callback();
        }
    };
    window.addEventListener('MOE_LIFECYCLE', handler);
};

// Sync MoEngage's persisted identity with the server's user
const reconcileIdentity = (userId) => {
    const identities = moengage.getUserIdentities();
    const currentUid = identities ? identities.uid : null;

    if (userId) {
        const serverUid = String(userId);
        if (currentUid === serverUid) {
            return;
        }
        if (currentUid) {
            // a different user is logged in locally, first logout to avoid profile merges
            moengage.logoutUser().then(() => moengage.identifyUser(serverUid));
        } else {
            moengage.identifyUser(serverUid);
        }
    } else if (currentUid) {
        // server has no user but MoEngage retains an identity, treat as logout
        moengage.logoutUser();
    }
};

const init = (cfg) => {
    if (initialized) return;
    const config = cfg || readGlobalCfg();

    if (!config.MOENGAGE_APP_ID) {
        // eslint-disable-next-line no-console
        console.warn('MOENGAGE_APP_ID missing, init skipped.');
        return;
    }

    const initConfig = {
        appId: config.MOENGAGE_APP_ID,
        cluster: config.MOENGAGE_CLUSTER,
        env: config.MOENGAGE_ENV,
        // Console log verbosity, 0 none / 1 critical / 2 all
        logLevel: config.MOENGAGE_DEBUG ? 2 : 0,
        disableWebPush: true,
    };
    if (config.MOENGAGE_PROXY_DOMAIN) {
        initConfig.customProxyDomain = config.MOENGAGE_PROXY_DOMAIN;
    }

    whenSdkReady(() => reconcileIdentity(config.MOENGAGE_USER_ID));

    moengage.initialize(initConfig);
    initialized = true;
};

const track = (event, props = {}) => {
    if (initialized) moengage.trackEvent(event, props);
};

const moengageWrapper = {
    init,
    track,
};

export default moengageWrapper;
